import { TmmvService } from '../../_services/tmmv.service';
import { Nodo } from '../../_models/utils/nodo';
import { TipoVersiones } from '../../_enums/tipoVersiones';
import { resolve } from 'url';
import { Loading } from './loading';
import * as cloneDeep from 'lodash/cloneDeep';
import { NgZone, Optional } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { Respuesta } from './respuesta';
import { VersionGenerica } from './version-generica';
import { Clasificacion } from './clasificacion';
import { TmmvMinimalNode } from '../arbol-lazy/tmmv-minimal-node';
import { NodoDescripcion } from '../arbol-lazy/nodo-descripcion';

export class TmmvNodo extends Nodo {
	activo: boolean;
	esVersion: boolean;
	idPadre: number;
	nombreDes: string;
	idCliente: number;
	padre: any;
	hijos: Array<any> = new Array<any>();
	esVersionParcial: boolean;
	expanded: boolean = false;
	alerta: number;
	codigo: string;
	marcarHijos: boolean;
	todosLosHijos: boolean;
	marcaNombre: string;
	modeloNombre: string;
	vigenciaDesde: Date;
	vigenciaHasta: Date;
	idVersion: number;
	tieneVersionesParciales: boolean;
	tienePrecio: boolean;
	tieneEquipamiento: boolean;
	idNombDes: number;

	constructor(params = undefined, recursive = true) {
		super(params);
		if (params != undefined) {
			this.idNodo = params.idNodo;
			this.activo = params.activo;
			this.esVersion = params.esVersion;
			this.tieneHijos = params.tieneHijos;
			this.idPadre = params.idPadre;
			this.nivel = params.nivel;
			this.nombreDes = params.nombreDes;
			this.idCliente = params.idCliente;
			this.nombre = params.nombre;
			if (recursive) this.instanceHijos(params.hijos);
			this.esVersionParcial = params.esVersionParcial;
			this.expanded = params.expanded;
			this.profundidad = params.nivel;
			this.marcarHijos = params.marcarHijos;
			this.codigo = params.codigo;
			this.todosLosHijos = params.todosLosHijos;
			this.vigenciaDesde = new Date(params.vigenciaDesde);
			this.vigenciaHasta = params.vigenciaHasta
				? new Date(params.vigenciaHasta)
				: undefined;
			this.tieneVersionesParciales = params.tieneVersionesParciales;
			this.tieneEquipamiento = params.tieneEquipamiento;
			this.tienePrecio = params.tienePrecio;
			this.idNombDes = params.idNombDes;
		}
	}

	public instanceHijos(hijos: Array<any>) {
		if (hijos != undefined) {
			hijos.forEach((hijo) => {
				if (this.selected && this.marcarHijos) {
					hijo.selected = true;
				}
				this.hijos.push(new TmmvNodo(hijo));
			});
		}
	}

	crearDesdeVersionGenerica(nodo: VersionGenerica) {
		if (!nodo) return;
		this.idNodo = nodo.idNodo;
		this.nombreDes = nodo.nombre;
		this.padre = new TmmvNodo();
		this.padre.crearDesdeVersionGenerica(nodo.padre);
	}

	crearDesdeClasificacion(clasificacion: Clasificacion) {
		if (!clasificacion) return;
		this.idNodo = clasificacion.idClasificacion;
		this.nombreDes = clasificacion.nombreDescripcion;
		this.profundidad = clasificacion.profundidad;
		this.padre = new TmmvNodo();
		this.padre.crearDesdeClasificacion(clasificacion.padre);
	}

	public static crearDesdeTmmMinimalCompleto(
		nodo: TmmvMinimalNode,
		conHijos: boolean = true
	) {
		if (!nodo) return;
		let node = new TmmvNodo();
		node.idNodo = nodo.id ?? 0;
		node.nombreDes = nodo.nd ?? '';
		node.profundidad = nodo.n ?? 0;
		node.tieneEquipamiento = nodo.te;
		node.tienePrecio = nodo.tp;
		node.padre = new TmmvNodo();
		node.padre.crearDesdeTmmMinimal(nodo.padre, false);
		node.activo = Boolean(nodo.a) ?? false;
		node.nivel = nodo.n ?? 0;
		node.esVersionParcial = Boolean(nodo.p) ?? false;
		node.vigenciaDesde = nodo.vd
			? new Date().fromNumber(nodo.vd)
			: undefined;
		node.vigenciaHasta = nodo.vh
			? new Date().fromNumber(nodo.vh)
			: undefined;
		node.hijos =
			nodo.h && conHijos
				? nodo.hijos.map((h) =>
						TmmvNodo.crearDesdeTmmMinimalCompleto(h)
				  )
				: undefined;
		node.codigo = nodo.c ?? '';
		node.expandido = nodo.expandido ?? false;
		node.selected = nodo.selected ?? false;
		node.indeterminate = nodo.indeterminate ?? false;
		node.idNombDes = nodo.in ?? 0;

		return node;
	}

	public asignarDescripciones(descripciones: Array<NodoDescripcion>) {
		for (let i = 0; i < this.hijos.length; i++) {
			const element = this.hijos[i];
			for (let j = 0; j < descripciones.length; j++) {
				if (descripciones[j].id == element.idNombDes) {
					this.hijos[i].nombreDes = descripciones[j].texto;
					descripciones.splice(j, 1);
				}
			}
		}
	}

    crearDesdeTmmMinimal(nodo: TmmvMinimalNode) {
        if (!nodo) return;
        this.idNodo = nodo.id;
        this.nombreDes = nodo.nd;
        this.profundidad = nodo.n;
        this.nivel = nodo.n;
        this.esVersionParcial = Boolean(nodo.p);
        this.padre = new TmmvNodo();
        this.padre.crearDesdeTmmMinimal(nodo.padre);
    }

	public getHijos(
		tmmvService: TmmvService,
		forzarArbolHeredado: boolean = true,
		marcarTodos: boolean,
		mostrarDiscontinuadas: boolean = false,
		mostrarParciales: boolean = false
	) {
		if (!this.esVersionParcial && this.hijos.length == 0) {
			var auxNodo: TmmvNodo = new TmmvNodo(undefined);
			auxNodo.idNodo = this.idNodo;
			auxNodo.activo = this.activo;
			auxNodo.esVersion = this.esVersion;
			auxNodo.tieneHijos = this.tieneHijos;
			auxNodo.idPadre = this.idPadre;
			auxNodo.nivel = this.nivel;
			auxNodo.nombreDes = this.nombreDes;
			auxNodo.idCliente = this.idCliente;
			auxNodo.nombre = this.nombre;
			auxNodo.esVersionParcial = this.esVersionParcial;
			auxNodo.hijos = this.hijos;
			auxNodo.selected = this.selected;
			auxNodo.profundidad = this.nivel;
			auxNodo.tieneVersionesParciales = this.tieneVersionesParciales;
			auxNodo.marcarHijos = marcarTodos;
			auxNodo.tieneEquipamiento = this.tieneEquipamiento;
			auxNodo.tienePrecio = this.tienePrecio;

			let nodosObservable: Observable<Respuesta> = tmmvService.getHijos(
				auxNodo,
				TipoVersiones.Todas,
				true,
				forzarArbolHeredado
			);
			nodosObservable.subscribe(
				(res) => {
					if (res.Succeed) {
						res.Data.forEach((element) => {
							element.selected =
								this.selected &&
								this.mostrarNodo(
									element,
									mostrarDiscontinuadas,
									mostrarParciales
								);
							element.marcarHijos = marcarTodos;
							element.padre = auxNodo;

							this.hijos.push(new TmmvNodo(element));
						});
					}
				},
				null,
				() => {}
			);

			return nodosObservable;
		}

		return undefined;
	}

	mostrarNodo(
		nodo: any,
		mostrarDiscontinuadas: boolean,
		mostrarParciales: boolean
	) {
		return (
			(mostrarDiscontinuadas || nodo.activo) &&
			(!nodo.esVersionParcial || mostrarParciales)
		);
	}

	public getHijosNuevo(
		tmmvService: TmmvService,
		forzarArbolHeredado: boolean = true,
		marcarTodos: boolean,
		selectedNodos: any[],
		eventRefSelectedNodos: any,
		selectedNodosConPadre: any[],
		eventRefNodosHijos: any,
		nodosEsperandoHijos: any[]
	) {
		if (!this.esVersionParcial && this.hijos.length == 0) {
			var auxNodo: TmmvNodo = new TmmvNodo(undefined);
			auxNodo.idNodo = this.idNodo;
			auxNodo.activo = this.activo;
			auxNodo.esVersion = this.esVersion;
			auxNodo.tieneHijos = this.tieneHijos;
			auxNodo.idPadre = this.idPadre;
			auxNodo.nivel = this.nivel;
			auxNodo.nombreDes = this.nombreDes;
			auxNodo.idCliente = this.idCliente;
			auxNodo.nombre = this.nombre;
			auxNodo.esVersionParcial = this.esVersionParcial;
			auxNodo.hijos = this.hijos;
			auxNodo.selected = this.selected;
			auxNodo.profundidad = this.nivel;
			auxNodo.tieneVersionesParciales = this.tieneVersionesParciales;
			auxNodo.marcarHijos = marcarTodos;
			auxNodo.tieneEquipamiento = this.tieneEquipamiento;
			auxNodo.tienePrecio = this.tienePrecio;

			nodosEsperandoHijos.push(auxNodo);
			eventRefNodosHijos.emit({
				nodosEsperandoHijos: nodosEsperandoHijos,
			});
			this.cargandoHijos = true;

			tmmvService
				.getHijos(
					auxNodo,
					TipoVersiones.Todas,
					true,
					forzarArbolHeredado
				)
				.subscribe(
					(res) => {
						if (res.Succeed) {
							res.Data.forEach((element) => {
								let estadoSeleccion: boolean = this.selected;

								if (estadoSeleccion) {
									if (
										(!this.incluirDiscontinuadas &&
											!element.activo) ||
										(!this.incluirParciales &&
											element.esVersionParcial)
									) {
										estadoSeleccion = false;
									}
								}

								element.selected = estadoSeleccion;
								element.marcarHijos = marcarTodos;
								element.idPadre = this.idNodo;
								//element.padre = auxNodo;

								let hijo: TmmvNodo = new TmmvNodo(element);

								if (
									element.selected &&
									!selectedNodos.find(
										(sn) =>
											sn.idNodo == hijo.idNodo &&
											sn.nivel == hijo.nivel
									)
								) {
									let hijoSeleccionado = cloneDeep(hijo);
									selectedNodosConPadre.push(hijo);
									hijoSeleccionado.hijos = [];
									hijoSeleccionado.padre = undefined;
									selectedNodos.push(hijoSeleccionado);
								}

								this.hijos.push(hijo);
							});
						}
					},
					() => {},
					() => {
						this.cargandoHijos = false;
						nodosEsperandoHijos.splice(
							nodosEsperandoHijos.indexOf(auxNodo),
							1
						);
						eventRefSelectedNodos.emit({
							selectedNodos: selectedNodos,
							selectedNodosConPadre: selectedNodosConPadre,
							esOnChanges: true,
						});
						eventRefNodosHijos.emit({
							nodosEsperandoHijos: nodosEsperandoHijos,
						});
					}
				);
		}
	}

	/*
        En caso de usar filtros por segmento (por ejemplo) o que requieran llegar al nivel version,
        a causa del lazy load del árbol debemos hacer un merge de los nodos (por id y profundidad).
        De esta manera, obtenemos los hijos y dejamos solo aquellos que cumplen el filtro
     */
	public getHijosAndMerge(
		tmmvService: TmmvService,
		forzarArbolHeredado: boolean = true,
		marcarTodos: boolean
	): void {
		let hijosFiltro: TmmvNodo[] = this.hijos.filter(
			(hijo) => !hijo.nombreDes || hijo.nombreDes == ''
		);
		if (
			!this.esVersionParcial &&
			(hijosFiltro.length || !this.hijos.length)
		) {
			var auxNodo: TmmvNodo = new TmmvNodo(undefined);
			auxNodo.idNodo = this.idNodo;
			auxNodo.activo = this.activo;
			auxNodo.esVersion = this.esVersion;
			auxNodo.tieneHijos = this.tieneHijos;
			auxNodo.idPadre = this.idPadre;
			auxNodo.nivel = this.nivel;
			auxNodo.nombreDes = this.nombreDes;
			auxNodo.idCliente = this.idCliente;
			auxNodo.nombre = this.nombre;
			auxNodo.esVersionParcial = this.esVersionParcial;
			auxNodo.selected = this.selected;
			auxNodo.profundidad = this.nivel;
			auxNodo.tieneVersionesParciales = this.tieneVersionesParciales;
			auxNodo.marcarHijos = marcarTodos;

			tmmvService
				.getHijos(
					auxNodo,
					TipoVersiones.Todas,
					true,
					forzarArbolHeredado
				)
				.subscribe(
					(res) => {
						if (res.Succeed) {
							res.Data.forEach((element) => {
								if (hijosFiltro && hijosFiltro.length) {
									let hijoFiltroActual = hijosFiltro.find(
										(hijoFiltro) =>
											hijoFiltro.idNodo ==
												element.idNodo &&
											hijoFiltro.nivel == element.nivel
									);
									if (hijoFiltroActual) {
										element.selected =
											hijoFiltroActual.selected;
										element.indeterminate =
											hijoFiltroActual.indeterminate;
										this.hijos.splice(
											this.hijos.indexOf(
												(hijo) =>
													hijo.idNodo ==
														element.idNodo &&
													hijo.nivel == element.nivel
											),
											1
										);
										this.hijos.push(new TmmvNodo(element));
									}
								} else {
									this.setElementInitData(
										element,
										marcarTodos,
										auxNodo
									);
									this.hijos.push(new TmmvNodo(element));
								}
							});
						}
					},
					null,
					null
				);
		}
	}

	public setElementInitData(element: any, marcarTodos, padre) {
		element.selected = this.selected;
		element.marcarHijos = marcarTodos;
		element.padre = padre;
	}
}
